"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var AmazonPayConfig = /*#__PURE__*/function () {
  function AmazonPayConfig(store, helpers, adyenPaymentMethods) {
    var _this = this,
      _window$Configuration;
    _classCallCheck(this, AmazonPayConfig);
    _defineProperty(this, "onClick", function (resolve, reject) {
      $('#dwfrm_billing').trigger('submit');
      if (_this.store.formErrorsExist) {
        reject();
      } else {
        resolve();
      }
    });
    this.showPayButton = true;
    this.productType = 'PayAndShip';
    this.checkoutMode = 'ProcessOrder';
    this.locale = ((_window$Configuration = window.Configuration) === null || _window$Configuration === void 0 ? void 0 : _window$Configuration.locale) || null;
    this.returnUrl = window.returnURL;
    this.store = store;
    this.helpers = helpers;
    this.adyenPaymentMethods = adyenPaymentMethods;
  }
  return _createClass(AmazonPayConfig, [{
    key: "setAmazonPayConfig",
    value: function setAmazonPayConfig(defaultConfig) {
      var _this$adyenPaymentMet, _this$adyenPaymentMet2;
      var amazonpay = (_this$adyenPaymentMet = this.adyenPaymentMethods) === null || _this$adyenPaymentMet === void 0 ? void 0 : (_this$adyenPaymentMet2 = _this$adyenPaymentMet.paymentMethods) === null || _this$adyenPaymentMet2 === void 0 ? void 0 : _this$adyenPaymentMet2.find(function (paymentMethod) {
        return paymentMethod.type === 'amazonpay';
      });
      if (amazonpay) {
        var _document$querySelect, _document$querySelect2, _document$querySelect3, _document$querySelect4, _document$querySelect5, _document$querySelect6, _document$querySelect7, _document$querySelect8;
        defaultConfig.configuration = amazonpay.configuration;
        defaultConfig.addressDetails = {
          name: "".concat((_document$querySelect = document.querySelector('#shippingFirstNamedefault')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.value, " ").concat((_document$querySelect2 = document.querySelector('#shippingLastNamedefault')) === null || _document$querySelect2 === void 0 ? void 0 : _document$querySelect2.value),
          addressLine1: (_document$querySelect3 = document.querySelector('#shippingAddressOnedefault')) === null || _document$querySelect3 === void 0 ? void 0 : _document$querySelect3.value,
          city: (_document$querySelect4 = document.querySelector('#shippingAddressCitydefault')) === null || _document$querySelect4 === void 0 ? void 0 : _document$querySelect4.value,
          stateOrRegion: (_document$querySelect5 = document.querySelector('#shippingAddressCitydefault')) === null || _document$querySelect5 === void 0 ? void 0 : _document$querySelect5.value,
          postalCode: (_document$querySelect6 = document.querySelector('#shippingZipCodedefault')) === null || _document$querySelect6 === void 0 ? void 0 : _document$querySelect6.value,
          countryCode: (_document$querySelect7 = document.querySelector('#shippingCountrydefault')) === null || _document$querySelect7 === void 0 ? void 0 : _document$querySelect7.value,
          phoneNumber: (_document$querySelect8 = document.querySelector('#shippingPhoneNumberdefault')) === null || _document$querySelect8 === void 0 ? void 0 : _document$querySelect8.value
        };
      }
    }
  }, {
    key: "getConfig",
    value: function getConfig() {
      var defaultConfig = {
        showPayButton: this.showPayButton,
        productType: this.productType,
        checkoutMode: this.checkoutMode,
        locale: this.locale,
        returnUrl: this.returnUrl,
        onClick: this.onClick
      };
      this.setAmazonPayConfig(defaultConfig);
      return defaultConfig;
    }
  }]);
}();
module.exports = AmazonPayConfig;